import React from "react";
import {Button, type ButtonProps} from "antd";

export const ActionButton: React.FC<ButtonProps> = (props) => {
    return (
        <Button
            style={{height: '60px', borderRadius: '59px', maxWidth: '298px', width: '100%'}}
            {...props}
        > {props.children} </Button>
    );
};